/**
 * Created by - Sameer on 07-11-2025
 * Reason - To have Product Detailed section
 */

import { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import style from "./ProductDetail.module.css";
import config from "../../Api/config";
import { getProductDetailsApi } from "../../Api/services";
import parse from "html-react-parser";
import { GlobalContext } from "../../context/Context";
import NavigationPath from "../../components/NavigationPath/NavigationPath";

const ProductDetail = () => {
  const [productDetails, setProductDetails] = useState([]);
  const [filteredProductDetails, setFilteredProductDetails] = useState([]);
  const [showContent, setShowContent] = useState(false);
  const location = useLocation();
  const productId = location.state;
  const { navigationPath, setNavigationPath } = useContext(GlobalContext);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    setNavigationPath([
      { name: "Home", path: "/" },
      { name: "Products", path: "/products" },
      { name: "Product Details", path: "/product_detail" },
    ]);

    if (productId != null && productId != "") {
      getProductDetails();
    }
  }, []);

  useEffect(() => {
    if (productDetails?.product_details != null) {
      const filteredProduct = productDetails.product_details.filter((product) => product.id == productId);
      setFilteredProductDetails(filteredProduct);
      setShowContent(true);
    }
  }, [productDetails, productId]);

  const getProductDetails = async () => {
    try {
      const response = await getProductDetailsApi();
      setProductDetails(response);
    } catch (error) {
      console.error("Error fetching product details:", error);
      setShowContent(true);
    }
  };

  return (
    <>
      {showContent ? (
        <div className={`${style.pageContainer}`}>
          <NavigationPath navigationPathArray={navigationPath} />

          <div className={`${style.content}`}>
            {filteredProductDetails?.map((product) => (
              <div key={product.id} className={`${style.productDetailsContainer}`}>
                <div className={`${style.productTitle}`}>{product.title}</div>
                
                <div className={`${style.imageContainer}`}>
                  <img
                    src={config.baseURL + product?.image}
                    alt={product.title || "Product Image"}
                    className={`${style.image}`}
                    onError={(e) => {
                      e.target.src = "/default-product.png";
                    }}
                  />
                </div>

                {product.overview && (
                  <div className={`${style.section}`}>
                    <h3 className={`${style.sectionTitle}`}>📊 Overview</h3>
                    <div className={`${style.sectionContent}`}>
                      {parse(product.overview)}
                    </div>
                  </div>
                )}

                {product.benefits && (
                  <div className={`${style.section}`}>
                    <h3 className={`${style.sectionTitle}`}>✨ Key Benefits</h3>
                    <div className={`${style.sectionContent}`}>
                      {parse(product.benefits)}
                    </div>
                  </div>
                )}

                {product.ROI && (
                  <div className={`${style.section}`}>
                    <h3 className={`${style.sectionTitle}`}>📈 Return on Investment (ROI)</h3>
                    <div className={`${style.sectionContent}`}>
                      {parse(product.ROI)}
                    </div>
                  </div>
                )}

                {product.functionalities && (
                  <div className={`${style.section}`}>
                    <h3 className={`${style.sectionTitle}`}>🔍 Functionalities </h3>
                    <div className={`${style.sectionContent}`}>
                      {parse(product.functionalities)}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className={style.loaderContent}>
          <img style={{ height: "30vh" }} src="adyant_loader.gif" alt="Loading..." />
        </div>
      )}
    </>
  );
};

export default ProductDetail;